import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import ArbitrationFormA1 from '../../../../../../assets/IAC/AECCI_IAC_FormA1.pdf';

const ArbitrationFormModal = ({ show, handleClose }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            className="pdf-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Arbitration Form - A1</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <iframe
                    src={ArbitrationFormA1}
                    style={{ width: '100%', height: '80vh' }}
                    title="Arbitration Form"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ArbitrationFormModal; 